import { Capacitor, registerPlugin } from "@capacitor/core";
import { getFunctions, httpsCallable } from "firebase/functions";
import { auth } from "../firebase";

/* Assinatura do Print Control pela Google Play (só no app Android).
   O plugin nativo (android/…/PlayBillingPlugin.java) abre a compra; quem libera
   o plano é o servidor (playVerificarAssinatura), que confere a compra na
   Google Play. Fica desligado até REACT_APP_PLAY_PRODUCT_ID existir no build
   (o id da assinatura no Play Console). Guia: docs/google-play-billing.md */

const PlayBilling = registerPlugin("PlayBilling");
export const PLAY_PRODUCT_ID = process.env.REACT_APP_PLAY_PRODUCT_ID || "";

export const playBillingDisponivel = () =>
  !!PLAY_PRODUCT_ID && Capacitor.getPlatform?.() === "android" && Capacitor.isPluginAvailable?.("PlayBilling") === true;

// Mesmo hash que o servidor confere (functions/playBilling/assinaturas.js → contaOfuscada)
export async function contaOfuscada(uid) {
  const dados = new TextEncoder().encode(`printcontrol:${uid}`);
  const hash = await crypto.subtle.digest("SHA-256", dados);
  return [...new Uint8Array(hash)].map(b => b.toString(16).padStart(2, "0")).join("");
}

// Preço como a Google Play mostra ao usuário (a loja exige esse, não o do site)
export async function precoNaPlay() {
  const r = await PlayBilling.produto({ productId: PLAY_PRODUCT_ID });
  return r?.preco || null;
}

const verificar = purchaseToken =>
  httpsCallable(getFunctions(auth.app, "us-central1"), "playVerificarAssinatura")({ purchaseToken, productId: PLAY_PRODUCT_ID }).then(r => r.data);

/* Compra → servidor confere. Devolve { ativo, expiraEm } ou { pendente: true }
   (pagamento ainda em processamento na Google Play: libera quando o servidor
   receber o aviso). Cancelar a compra rejeita com code "USER_CANCELED". */
export async function assinarPelaPlay(uid) {
  const compra = await PlayBilling.comprar({ productId: PLAY_PRODUCT_ID, contaOfuscada: await contaOfuscada(uid) });
  if (compra?.pendente) return { pendente: true };
  return verificar(compra.purchaseToken);
}

// Já assinou (outro aparelho, reinstalou o app): o servidor confere a compra ativa
export async function restaurarPelaPlay() {
  const { compras = [] } = await PlayBilling.compras();
  const minha = compras.find(c => c?.productId === PLAY_PRODUCT_ID && !c.pendente);
  return minha ? verificar(minha.purchaseToken) : { ativo: false, semCompra: true };
}

export const compraCancelada = e => e?.code === "USER_CANCELED";

export function mensagemPlay(e) {
  if (compraCancelada(e)) return "";
  const codigo = String(e?.code || "");
  if (codigo.includes("failed-precondition") && e?.message) return e.message;
  return "Não foi possível concluir a assinatura pela Google Play. Tente de novo.";
}
